// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__442-F","inner":"Form_inner__2EpF3","range":"Form_range__3t_ZE","name":"Form_name__eJInb","actions":"Form_actions__3OkYD"};